/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Select_Guide_PromptInputs */



/**
* | output |
* | --- |
* | "Select a KNP guide from the list or create a new one." |
*
* @param {Knp_Manager_Select_Guide_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_select_guide_prompt = /** @type {((inputs?: Knp_Manager_Select_Guide_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Select_Guide_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez un guide KNP dans la liste ou créez-en un nouveau.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen KNP-Führer aus der Liste aus oder erstellen Sie einen neuen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona una guida KNP dall'elenco o creane una nuova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите гида по КНП из списка или создайте нового.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione una guía KNP de la lista o cree una nueva.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从列表中选择一位克鲁格国家公园 (KNP) 导游，或者创建一个新的导游。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リストから KNP ガイドを選択するか、新しいガイドを作成します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूची में से एक केएनपी गाइड चुनें या एक नया गाइड बनाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um guia do Parque Nacional Kruger na lista ou crie um novo.")
	return /** @type {LocalizedString} */ ("Select a KNP guide from the list or create a new one.")
});